module.exports = __webpack_public_path__ + "assets/img/mtTitle-8aee446c.png";